<template>
  <div>
    <cms-timeline
      v-if="timelineSetUp"
      :theme="timelineOptions"
      :timeline="homepage.timeline[id]"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useTranslationStore } from '../../../../stores/translationStore.js';
import isEmpty from 'lodash/isEmpty';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const homepage = computed(() => mainStore.homepage);
const theme = computed(() => mainStore.theme);
const isThemePreview = computed(() => mainStore.isThemePreview);

const id = computed(() => {
  if (isThemePreview.value) {
    return 'preview_id';
  }
  return `${props.containerId}_${props.componentIdx}`;
});

const timelineOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: {
      ...translationStore.getComponentTranslation('spotlight'),
      ...translationStore.getGlobalTranslations,
    },
    globalThemeSettings: mainStore.getGlobalThemeSettings,
  };
});

const timelineSetUp = computed(() => !isEmpty(homepage.value?.timeline?.[id.value]?.items));
</script>
